import { URLS } from '@constants'
import {
  CopyContextMenu,
  CREATEContextMenu,
  GETContextMenu,
  GETObjectDataParams,
  UPDATEContextMenu,
} from '@types'

import { commonAPI } from './common.api'

export const contextMenuApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchContextMenuList: build.query<GETContextMenu[], GETObjectDataParams | void>({
      query: params => ({
        url: URLS.FRONT_CFG + '/menu/context',
        params: {
          page: params?.page,
          size: params?.size,
          sort: params?.sort,
          searchPattern: params?.searchPattern,
          objectCode: params?.objectCode,
        },
      }),
      providesTags: ['ContextMenuList', 'AllConfigs'],
    }),
    fetchContextMenuById: build.query<GETContextMenu, string | number>({
      query: (id: string) => ({
        url: URLS.FRONT_CFG + `/menu/context/id/${id}`,
      }),
      providesTags: ['SingleContextMenu', 'AllConfigs'],
    }),
    fetchGanttContextMenuById: build.mutation<GETContextMenu, string | void>({
      query: (id: string) => ({
        url: URLS.FRONT_CFG + `/menu/context/id/${id}`,
      }),
    }),
    createContextMenu: build.mutation<GETContextMenu, CREATEContextMenu>({
      query: elements => ({
        url: URLS.FRONT_CFG + `/menu/context`,
        method: 'POST',
        body: elements,
      }),
      invalidatesTags: ['ContextMenuList'],
    }),
    updateContextMenu: build.mutation<GETContextMenu, UPDATEContextMenu>({
      query: ({ elements }) => ({
        url: URLS.FRONT_CFG + `/menu/context`,
        method: 'POST',
        body: elements,
      }),
      invalidatesTags: ['ContextMenuList', 'SingleContextMenu'],
    }),
    copyContextMenu: build.mutation<GETContextMenu, CopyContextMenu>({
      query: contextMenuData => ({
        url: URLS.FRONT_CFG + '/menu/context/copy',
        method: 'POST',
        body: contextMenuData,
      }),
      invalidatesTags: ['ContextMenuList'],
    }),
    deleteContextMenu: build.mutation<GETContextMenu, string | number>({
      query: id => ({
        url: URLS.FRONT_CFG + `/menu/context/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ContextMenuList'],
    }),
  }),
})

export const {
  useCopyContextMenuMutation,
  useCreateContextMenuMutation,
  useDeleteContextMenuMutation,
  useFetchContextMenuByIdQuery,
  useFetchGanttContextMenuByIdMutation,
  useUpdateContextMenuMutation,
  useFetchContextMenuListQuery,
  useLazyFetchContextMenuByIdQuery,
} = contextMenuApi
